import { IS_RTL_DIRECTION } from 'consts'

import { motion } from 'framer-motion'
import styled, { css } from 'styled-components'
import { flexCenterMixin, absoluteElementAlignCenterMixin } from 'styles/mixins'

const _getHorizontalPosition = () => {
  return IS_RTL_DIRECTION
    ? css`
        left: 12px;
      `
    : css`
        right: 12px;
      `
}

const _staticViewStyles = css`
  height: 100%;
  width: 30px;
  display: flex;
  justify-content: center;
  align-items: center;
`

const _absoluteViewStyles = css`
  position: absolute;
  ${_getHorizontalPosition}
  ${absoluteElementAlignCenterMixin()}
  ${flexCenterMixin()}
`
export const CrossIcon = styled(motion.div)<{ $isStaticView: boolean }>`
  cursor: pointer;
  ${({ $isStaticView }) =>
    $isStaticView ? _staticViewStyles : _absoluteViewStyles}

  svg {
    width: 18px;
    height: 18px;
  }
`
